import { createContext } from 'react';

import type { KeyboardEvent } from '../../core/types/events.js';

/** @internal */
export interface TerminologyOverlayContextType {
  isDisabled?: boolean;
  'aria-expanded'?: boolean | 'true' | 'false';
  'aria-haspopup'?:
    | boolean
    | 'menu'
    | 'listbox'
    | 'tree'
    | 'grid'
    | 'dialog'
    | 'true'
    | 'false';
  'aria-controls'?: string;
  onKeyDown?: (e: KeyboardEvent) => void;
}

export const TerminologyOverlayContext =
  createContext<TerminologyOverlayContextType>({});
